
























import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import en from "vuetify/es5/locale/en";
import VueI18n from "vue-i18n";

@Component({
  components: {},
})
export default class MyNumberField extends Vue {
  @Prop({ default: "" }) id?: string;
  @Prop({ default: false }) required: boolean;
  @Prop({ default: true }) redIcon: boolean;
  @Prop({ default: "" }) label: string | VueI18n.TranslateResult;

  @Prop({ default: null }) decimalLimit?: number;

  get identifier() {
    return this.id ? this.id : this.lodash.uniqueId(`mynumberfield-${new Date().getTime()}-`);
  }

  get onInputCheck() {
    const limit = this.decimalLimit !== null ? this.decimalLimit : null;
    return `
    const maxVal = this.getAttribute('max');
    const minVal = this.getAttribute('min');
    
    if (maxVal !== null && Number(this.value) > Number(maxVal)) {
        this.value = maxVal;
        this.dispatchEvent(new Event('input', { bubbles: true }));
        return;
    };
    if (minVal !== null && Number(this.value) < Number(minVal)) {
        this.value = minVal;
        this.dispatchEvent(new Event('input', { bubbles: true }));
        return;
    };
    
    const decimalValue = (this.value+"").split(".")[1] || (this.value+"").split(",")[1];
    if (decimalValue && decimalValue.length) {
        const decimalValueMax = (maxVal+"").split(".")[1] || (maxVal+"").split(",")[1];
        if (${limit} !== null) {
            if (decimalValue.length > ${limit}) {
                const intValue = (this.value+"").split(".")[0] || (this.value+"").split(",")[0];
                this.value = intValue + '.' + decimalValue.slice(0, ${limit});
                this.dispatchEvent(new Event('input', { bubbles: true }));
                return;
            }
        } else if (decimalValueMax !== undefined) {
            if (decimalValue.length > decimalValueMax.length) {
                const intValue = (this.value+"").split(".")[0] || (this.value+"").split(",")[0];
                this.value = intValue + '.' + decimalValue.slice(0, decimalValueMax.length);
                this.dispatchEvent(new Event('input', { bubbles: true }));
                return;
            }
        }
    }
  `;
  }

  onKeyDownCheck = `return event.keyCode !== 69`;
}
